import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_TOPIC = "GET_LIST_TOPIC";
export const GET_LIST_TOPIC_ERROR = "GET_LIST_TOPIC_ERROR";
export const GET_LIST_TOPIC_SUCCESS = "GET_LIST_TOPIC_SUCCESS";

export const GET_DATA_TREE = "GET_DATA_TREE";
export const GET_DATA_TREE_ERROR = "GET_DATA_TREE_ERROR";
export const GET_DATA_TREE_SUCCESS = "GET_DATA_TREE_SUCCESS";

export const COUNT_LIST_TOPIC = "COUNT_LIST_TOPIC";
export const COUNT_LIST_TOPIC_ERROR = "COUNT_LIST_TOPIC_ERROR";
export const COUNT_LIST_TOPIC_SUCCESS = "COUNT_LIST_TOPIC_SUCCESS";

export const ADD_NEW_TOPIC = "ADD_NEW_TOPIC";
export const ADD_NEW_TOPIC_ERROR = "ADD_NEW_TOPIC_ERROR";
export const ADD_NEW_TOPIC_SUCCESS = "ADD_NEW_TOPIC_SUCCESS";

export const EDIT_A_TOPIC = "EDIT_A_TOPIC";
export const EDIT_A_TOPIC_SUCCESS = "EDIT_A_TOPIC_SUCCESS";
export const EDIT_A_TOPIC_ERROR = "EDIT_A_TOPIC_ERROR";

export const DELETE_A_TOPIC = "DELETE_A_TOPIC";
export const DELETE_A_TOPIC_SUCCESS = "DELETE_A_TOPIC_SUCCESS";
export const DELETE_A_TOPIC_ERROR = "DELETE_A_TOPIC_ERROR";

/**
 * Reducer
 */

const initialState = {
  topic: [],
  error: false,
  count: 0,
  loading: false,
  tree: [],
};

export const topicReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_TOPIC:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_TOPIC_SUCCESS:
      return {
        ...state,
        loading: false,
        listTopic: action.payload,
      };
    case GET_LIST_TOPIC_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_TOPIC:
      return {
        ...state,
      };
    case COUNT_LIST_TOPIC_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_TOPIC_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_TOPIC:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_TOPIC_SUCCESS:
      return {
        ...state,
        loading: false,
        topic: action.payload,
      };
    case ADD_NEW_TOPIC_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_TOPIC:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_TOPIC_SUCCESS: {
      const newItems = state.topic.filter((item) => item.id !== action.data.id);
      return {
        ...state,
        loading: false,
        newItems,
      };
    }
    case EDIT_A_TOPIC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_TOPIC:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_TOPIC_SUCCESS:
      return {
        ...state,
        loading: false,
        topic: action.payload,
      };
    case DELETE_A_TOPIC_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    ///tree
    case GET_DATA_TREE:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_TREE_SUCCESS:
      return {
        ...state,
        loading: false,
        tree: action.payload,
      };
    case GET_DATA_TREE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListTopic = (order, limit, skip, where) => ({
  type: GET_LIST_TOPIC,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const getDataTree = (keyword) => ({
  type: GET_DATA_TREE,
  data: {
    keyword,
  },
});

export const countListTopic = (where) => ({
  type: COUNT_LIST_TOPIC,
  data: {
    where,
  },
});

export const addNewTopic = (title, description, tags, parentId, priority) => ({
  type: ADD_NEW_TOPIC,
  data: {
    title,
    description,
    tags,
    parentId,
    priority,
  },
});

export const editTopic = (
  id,
  title,
  description,
  tags,
  parentId,
  priority
) => ({
  type: EDIT_A_TOPIC,
  data: {
    id,
    title,
    description,
    tags,
    parentId,
    priority,
  },
});

export const deleteTopic = (id) => ({
  type: DELETE_A_TOPIC,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListTopic,
      countListTopic,
      addNewTopic,
      editTopic,
      deleteTopic,
      getDataTree,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListTopicApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/topic", { order, limit, skip, ...where });
};

const getDataTreeApi = (keyword) => {
  return apiCaller.get("/mini-crm/topic/get-data-tree", { ...keyword });
};

const countListTopicApi = (where) => {
  return apiCaller.getData("/mini-crm/topic/count", { ...where });
};

const addNewTopicApi = (title, description, tags, parentId, priority) => {
  return apiCaller.postRequest("/mini-crm/topic", {
    title,
    description,
    ...tags,
    parentId: parentId ? parentId : "",
    priority,
  });
};
const editTopicApi = (id, title, description, tags, parentId, priority) => {
  return apiCaller.putRequest(`/mini-crm/topic/${id}`, {
    title,
    description,
    ...tags,
    parentId: parentId ? parentId : "",
    priority,
  });
};
const deleteTopicApi = (id) => {
  return apiCaller.del(`/mini-crm/topic/${id}`);
};

/**
 * sagas
 */

export const getListTopicFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_TOPIC);
    try {
      const res = yield call(
        getListTopicApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_TOPIC_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_TOPIC_ERROR, error });
    }
  }
};

export const getDataTreeFlow = function* () {
  while (true) {
    const action = yield take(GET_DATA_TREE);
    try {
      const res = yield call(getDataTreeApi, action.data.keyword);
      yield put({ type: GET_DATA_TREE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_DATA_TREE_ERROR, error });
    }
  }
};

export const countTopicFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_TOPIC);
    try {
      const res = yield call(countListTopicApi, action.data.where);
      yield put({ type: COUNT_LIST_TOPIC_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_TOPIC_ERROR, error });
    }
  }
};

export const addNewTopicFlow = function* () {
  while (true) {
    const {
      data: { title, description, tags, parentId, priority },
    } = yield take(ADD_NEW_TOPIC);
    try {
      const res = yield call(
        addNewTopicApi,
        title,
        description,
        tags,
        parentId,
        priority
      );
      yield put({ type: ADD_NEW_TOPIC_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_NEW_TOPIC_ERROR, error });
    }
  }
};

export const editTopicFlow = function* () {
  while (true) {
    const {
      data: { id, title, description, tags, parentId, priority },
    } = yield take(EDIT_A_TOPIC);
    try {
      const res = yield call(
        editTopicApi,
        id,
        title,
        description,
        tags,
        parentId,
        priority
      );
      yield put({ type: EDIT_A_TOPIC_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_A_TOPIC_ERROR, error });
    }
  }
};

export const deleteTopicFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_TOPIC);
    try {
      const res = yield call(deleteTopicApi, action.data.id);
      yield put({ type: DELETE_A_TOPIC_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_A_TOPIC_ERROR, error });
    }
  }
};
